// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"fa36c497","453":"067237c9"}[chunkId] + ".chunk.js";
};